<template>
  <v-app app>
  
    <v-overlay v-if="isUnderMaintenance !== 2 || (isUnderMaintenance === 2 && ($store.state.loggedInUser.user_id == '39840' || $store.state.loggedInUser.user_id == '06995' || $store.state.loggedInUser.user_id == 'CRS2025'))" :value="loader">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
   <app-header v-if="isUnderMaintenance !== 2 || (isUnderMaintenance === 2 && ($store.state.loggedInUser.user_id == '39840' || $store.state.loggedInUser.user_id == '06995' || $store.state.loggedInUser.user_id == 'CRS2025'))"></app-header>
   <!-- v-show="$route.name !== 'Maintenance'" -->
   <app-alert v-if="isUnderMaintenance !== 2 || (isUnderMaintenance === 2 && ($store.state.loggedInUser.user_id == '39840' || $store.state.loggedInUser.user_id == '06995' || $store.state.loggedInUser.user_id == 'CRS2025'))"></app-alert>
   <app-loader v-if="isUnderMaintenance !== 2 || (isUnderMaintenance === 2 && ($store.state.loggedInUser.user_id == '39840' || $store.state.loggedInUser.user_id == '06995' || $store.state.loggedInUser.user_id == 'CRS2025'))"></app-loader>
      <v-main >
         <v-overlay :value="loaderx">
            <v-progress-circular
                  indeterminate
                  :size="120"
                  :width="3"
            ></v-progress-circular>Downloading, please wait...
         </v-overlay>
         <router-view ></router-view>
      </v-main>
  </v-app>
</template>

<script>
import {mapState} from 'vuex';
import Header from '../modules/Header.vue';
import Alert from '../modules/Alert.vue';
import Loader from '../modules/Loader.vue';
import moment from 'moment';
import Swal from 'sweetalert2';
   export default {
      components: {
         "app-header" : Header,
         "app-alert" : Alert,
         "app-loader" : Loader,
      },

      data: () => ({
         isUnderMaintenance: null,
         loader: false,
         drawer: null,
         csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      }),
      created(){

      },
      methods: {
         //NOTE - REQUEST CODE SSD25-0227783-2028(2025/03/28)
         async getSytemMaintenanceDatetime(){
            await axios({
                method: 'get',
                url: 'api/system_maintenance_datetime'
            }).then(({data}) => {
                this.isUnderMaintenance = data[0].is_undermaintenance;
            })
        },

         newRouteForCadRequest(){
            if (this.$route.path === '/main') {
               // this.$store.commit('logout');
               this.$router.push({ path: '/cadrequest' });
            }
         },
         showCustomUnsupportedBrowserModal() {
            Swal.fire({
               icon: 'error',
               title: 'You are using a browser that is not supported by the system!',
               html: `Please switch to <span style="color: red;">Google Chrome</span>.`,
               customClass: {
                  confirmButton: 'btn btn-danger',
               },
               buttonsStyling: false,
               confirmButtonText: '', // Empty text to hide the confirm button
               allowOutsideClick: false, // Prevent closing by clicking outside the modal
               allowEscapeKey: false, // Prevent closing with the Escape key
               showCancelButton: false, // Hide the Cancel button
               showCloseButton: false, // Hide the close (X) button
            });
         },
      },
      mounted() {
         //NOTE - REQUEST CODE SSD25-0227783-2028(2025/03/28)
         this.getSytemMaintenanceDatetime();
         
         this.newRouteForCadRequest();
         if (!this.$store.state.isChrome || /Edg/.test(navigator.userAgent)) {
            // Show a custom Swal modal for unsupported browsers
            this.showCustomUnsupportedBrowserModal();
         }
         // window.addEventListener("beforeunload", (event) => {
         //    if (PerformanceNavigationTiming.type != 1) {
         //       const HEADERS = {
         //          'X-CSRF-TOKEN' : document.querySelector('meta[name="csrf-token"]').getAttribute('content')
         //       }
         //       this.$store.commit('logout');
         //       let formdata = new FormData();
         //       formdata.append('_token', HEADERS['X-CSRF-TOKEN']);
         //       axios.post('/logout', formdata, { headers: HEADERS}).finally(() =>  location.reload());
         //    }
         //    return false;
         // });
      },

      async beforeCreate(){
         await this.$store.dispatch('cadRequestVer').then(() => {
            this.$store.state.verHeader = this.cadRequestVersion.version
            // console.log(this.verHeader, 'from app')
         })
         //NOTE : Case when laravel passport returns token mismatch, to destroy created web session. 
         //NOTE : need to destroy both passport access token and web guard session.
         // console.log(this.$store.state.loggedInUser)
         if( (JSON.stringify(this.$store.state.loggedInUser) === JSON.stringify({}) || !this.$store.state.loggedInUser)){
            this.loader = true;
            alert('UNAUTHORIZED')
            const HEADERS = {
                  'X-CSRF-TOKEN' : document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            }

            this.$store.commit('logout');
            let formdata = new FormData();
            formdata.append('_token', HEADERS['X-CSRF-TOKEN']);
            axios.post('/logout', formdata, { headers: HEADERS}).finally(() =>  location.reload());
         
         }

      },


      computed: {
         ...mapState([
            'loggedInUser',
            'cadRequestVersion',
            'verHeader',
            'isChrome',
            'loaderx',
         ])

      },
      
   }
</script>